import React from 'react';
import { MehrstufigerWorkflow } from '../inhalte/MehrstufigerWorkflow';
import { EMAIL_WORKFLOWS } from '../inhalte/workflowVarianten';

const EmailWorkflowPage: React.FC = () => <MehrstufigerWorkflow config={EMAIL_WORKFLOWS} />;

export default EmailWorkflowPage;
